import {Component, ViewChild} from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { SignaturePad } from "angular2-signaturepad/signature-pad";
import { AlertController } from "ionic-angular";
import { ApiService } from "../../services/api.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'page-profile',
  templateUrl: 'profile.html',
})
export class ProfilePage {

  profileForm: FormGroup;
  isDrawing = false;
  signature = '';
  formLoaded = false;
  skills:any = {};
  subscriptions = [];

  @ViewChild('signaturepad1') signaturePad1: SignaturePad;

  signaturePadOptions = { // Check out https://github.com/szimek/signature_pad
    'minWidth': 2,
    'canvasWidth': 600,
    'canvasHeight': 200,
    'backgroundColor': '#F1F1F1',
    'penColor': '#000000'
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public alertCtrl: AlertController,
    public translate: TranslateService,
    public apiService: ApiService
  ) {
    this.profileForm = this.formBuilder.group({
      firstname: new FormControl({ value: '', disabled: true }),
      lastname: new FormControl({ value: '', disabled: true }),
      email: ['', Validators.compose([Validators.email, Validators.required])],
      mobile: ['', Validators.required],
      preferred_lang: ['', Validators.required],
      handheld_title: new FormControl({ value: '', disabled: true }),
      vakpaspoort_nr: new FormControl({ value: '', disabled: true }),
      account_nr: new FormControl({ value: '', disabled: true }),
      user_signature: ['']
    });
  }

  save(){
    this.apiService.setProfile(this.profileForm.value).then(() => {
      if(this.profileForm.value.preferred_lang) {
        this.translate.use(this.profileForm.value.preferred_lang);
      }
      this.alertCtrl.create({
        title: this.translate.instant('Profiel gewijzigd'),
        message: this.translate.instant('Uw profiel is opgeslagen.'),
        buttons: [{
          text: 'OK',
          handler: () => {
            this.navCtrl.goToRoot({});
          }
        }]
      }).present();
    }).catch(() => {
      this.alertCtrl.create({
        title: this.translate.instant('Fout'),
        message: this.translate.instant('Uw profiel kon niet gewijzigd worden.'),
        buttons: ['OK']
      }).present();
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProfilePage');
    this.apiService.getProfile().then((data) => {
      // @ts-ignore
      let form_data:any = data.company_user;
      if(form_data.handheld && form_data.handheld.title){
        form_data.handheld_title = form_data.handheld.title;
      }
      if(form_data.user_signature){
        this.signature = form_data.user_signature;
      }
      if(form_data.skills){
        this.skills = form_data.skills;
      }
      if(form_data.company.account_nr){
        form_data.account_nr = form_data.company.account_nr;
      }
      if(form_data.subscriptions && form_data.subscriptions.length > 0){
        this.subscriptions = form_data.subscriptions;
      }
      // @ts-ignore
      this.profileForm.patchValue(form_data);
      this.formLoaded = true;
    }).catch(() => {
      this.alertCtrl.create({
        title: this.translate.instant('Fout'),
        message: this.translate.instant('Uw profiel kon niet geladen worden.'),
        buttons: [{
          text: 'OK',
          handler: () => {
            this.navCtrl.goToRoot({});
          }
        }]
      }).present();
    });
  }

  clearPad1(){
    this.signaturePad1.clear();
    this.profileForm.controls['user_signature'].setValue('');
  }

  drawComplete1() {
    this.isDrawing = false;
    this.profileForm.controls['user_signature'].setValue(this.signaturePad1.toDataURL());
  }

  drawStart() {
    this.isDrawing = true;
  }

}



// WEBPACK FOOTER //
// ./src/pages/profile/profile.ts